import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'


export default {

    async [actionTypes.AGENDA.BUSCAR_DENTISTAS]() {
        const {data} = await api.agenda.buscarDentistas()
        return data
    },

    async [actionTypes.AGENDA.BUSCAR_EVENTOS](context, dados) {
        const {data} = await api.agenda.buscarEventos(dados)
        return data
    },

    async [actionTypes.AGENDA.ADICIONAR_EVENTO](context, dados) {
        await api.agenda.adicionarEvento(dados)
    },

    async [actionTypes.AGENDA.REMOVER_EVENTO](context, eventoId) {
        await api.agenda.removerEvento(eventoId)
    },

    async [actionTypes.AGENDA.EDITAR_EVENTO](context, dados) {
        const {data} = await api.agenda.editarEvento(dados)
        return data
    },

    async [actionTypes.AGENDA.EDITAR_DETALHES_DENTISTA](context, dados) {
        await api.agenda.editarDetalhesDentista(dados)
    },

    async [actionTypes.AGENDA.BUSCAR_TODOS_DENTISTAS_SEM_PAGINACAO](context, conteudo) {
        const {data} = await api.agenda.buscarTodosSemPaginacao(conteudo)
        return data
    },
}